import axiosInstance from '../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../common/tab/tabActions';

const INITIAL_VALUES = {
  ativo: 1,
  ordem: 0,
  tipo: 'deteccao',
};

export function getList() {
  const request = axiosInstance.get('/cameras');

  return {
    type: 'CAMERA_FETCHED',
    payload: request,
  };
}

export function getAccessList(tipo) {
  const request = axiosInstance.get('/cameras', {
    params: { tipo, ativo: 1 },
  });

  return {
    type: 'CAMERA_ACCESS_FETCHED',
    payload: request,
  };
}

export function getControladoresList() {
  const request = axiosInstance.get('/controladores');

  return {
    type: 'CAMERA_CONTROLADORES_FETCHED',
    payload: request,
  };
}

export const setPaginaAtual = pagina => ({
  type: 'CAMERA_PAGE',
  payload: pagina,
});

export function create(values) {
  return submit(values, 'post');
}

export function update(values) {
  return submit(values, 'put');
}

export function remove(values) {
  return submit(values, 'delete');
}

function buildPayload(values) {
  return {
    ...values,
    controlador_id: Number(values.controlador_id),
    ordem: Number.isFinite(Number(values.ordem)) ? Number(values.ordem) : 0,
    ativo: Number(values.ativo) === 0 ? 0 : 1,
  };
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const url = method === 'post' ? '/cameras' : `/cameras/${id}`;
    const payload = buildPayload(values);

    axiosInstance[method](url, payload)
      .then(() => {
        toastr.success('Sucesso', 'Operação realizada com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const errors = (e.response && e.response.data && e.response.data.errors) || ['Erro ao processar a solicitação.'];
        errors.forEach(error => toastr.error('Erro', error));
      });
  };
}

export function showUpdate(camera) {
  return [
    showTabs('tabUpdate'),
    selectTab('tabUpdate'),
    initialize('cameraForm', {
      ...camera,
      controlador_id: camera.controlador_id ? String(camera.controlador_id) : '',
      ativo: Number(camera.ativo) === 0 ? 0 : 1,
    }),
  ];
}

export function init() {
  return [
    showTabs('tabList', 'tabCreate'),
    selectTab('tabList'),
    getList(),
    getControladoresList(),
    initialize('cameraForm', INITIAL_VALUES),
  ];
}
